import { useState } from 'react';
import '../styles.scss';
import { Tabs, Pagination } from 'antd';

import { SettingOutlined, EyeOutlined } from '@ant-design/icons';
import { TabsProps } from 'antd/lib';
import SurveyInformationDetail from './SurveyInformationDetail';
import MegaTable from '../../../components/MagaTableV2';
import { formatNumber } from '../../../services/mixin';

export default function SurveyInformation({ stData = {} as any, stChange = (data: any) => { } }) {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.survey?.list.map((col: any) => {
      if (col.field === 'customer_name') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          cellRenderer: (params: any) => {
            return (
              <div className={params.data.customer_name_id !== 'Không xác định' && params.data.customer_name_id ? 'cus-link-detail' : ''}>
                <a className="color-bage d-none" href={`/customer/pooling-data/customer-list/detail?id_sync=${params.data.customer_name_id}`}>{params.data.customer_name}</a>
                <span className="text">{params.data.customer_name || 'Không xác định'}</span>
              </div>
            )
          },
        });
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
      children: <SurveyInformationDetail stData={stData} stChange={(data) => stChange({...stData, ...data})} />,
    },
  ];

  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheSurveyInformation',
    col: [
      {
        headerName: 'Hành động',
        field: 'action',
        width: 100,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
          if (Object.prototype.hasOwnProperty.call(params.data || {}, 'has_brand_permission') && params.data.has_brand_permission !== true) {
            return null;
          }
          return (
            <div className='d-flex gap-4 justify-start align-center  h-full'>
              <EyeOutlined
                className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer}`}
                onClick={() => {
                  stChange({ thongtinkhaosat_show: params.data })
                  setRowActive(params?.node?.rowIndex);
                }}
              />
            </div>
          )
        },
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // { headerName: 'Ngày', field: 'doc_date' },
      // { headerName: 'Đơn vị', field: 'branch_name' },
      // { headerName: 'Điểm bán hàng', field: 'route_name' },
      // { headerName: 'Loại tương tác', field: 'Loại tương tác' },
      // { headerName: 'Phân loại liên hệ', field: 'Phân loại liên hệ' },
      // { headerName: 'Người liên hệ', field: 'customer_name' },
      // { headerName: 'Tên xe', field: 'vehicle_name' },
      // { headerName: 'Kết quả sau xử lý', field: 'Kết quả sau xử lý' },
      // { headerName: 'Trạng thái kết thúc', field: 'Trạng thái kết thúc' },
      // { headerName: 'Ngày kết thúc', field: 'Ngày kết thúc' },
    ],
    listData: [],
    selectedRowKeys: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });
  const [rowActive, setRowActive] = useState<number>(-1);
  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.customers_surveys, rowActive, loading: stData.customers_surveys_loading }}
            stChange={(data) => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
          <div className={`t-table-block t-table-customer c-table-scoll-x `}>
            <div className="pagination-block">
              <Pagination
                className='rs-pagination'
                showSizeChanger
                total={stData.customers_surveys_total}
                defaultPageSize={stData.customers_surveys_params_limit}
                current={stData.customers_surveys_params_page}
                pageSizeOptions={['10', '20', '50', '100']}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() => `Tổng cộng ${Math.ceil(stData.customers_surveys_total / stData.customers_surveys_params_limit) === 0 ? 1 : Math.ceil(stData.customers_surveys_total / stData.customers_surveys_params_page)} trang`}
                locale={{ items_per_page: 'trang' }}
                onChange={(page, pageSize) => {
                  stChange({
                    customers_surveys_params_page: page,
                    customers_surveys_params_limit: pageSize,
                    customers_surveys_loading: true,
                  })
                }}
              />
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <Tabs defaultActiveKey="1" items={items} className='w-full' />
        </div>
      </div>
    </>
  )
}
